import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const DoughnutChart = ({ elementId, color, dataValue, graphBorder }) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
 
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    const data = {
      labels: ["Scored", "Remaining"],
      datasets: [
        {
          data: [dataValue, 100 - dataValue],  
          // backgroundColor: [color, "transparent"],
            backgroundColor: [color, "#FF0000"],  
          borderWidth: 0,
          cutout: graphBorder,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      // borderRadius: 50,
      cutoutPercentage: 80, 
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
        },
      },
    };

    // Create the chart instance
    chartInstanceRef.current = new Chart(ctx, {
      type: "doughnut",
      data: data,
      options: options,
    });

    return () => { 
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [color, dataValue, graphBorder]);

  return <canvas id={elementId} ref={canvasRef} style={{ width: "100%", height: "100%" }}></canvas>;
};

export default DoughnutChart;
